import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { UserRole } from '../types/auth.types';
import { useAuth } from '../contexts/AuthContext';
import Main from '../components/layout/Main';

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  roles?: UserRole[];
  path: string;
  withLayout?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  roles,
  withLayout = true, // Par défaut, on enveloppe avec le layout Main
  ...rest
}) => {
  const { user, isAuthenticated, hasAnyRole } = useAuth();
  
  return (
    <Route
      {...rest}
      render={props => {
        // Vérifier si l'utilisateur est authentifié
        if (!isAuthenticated || !user) {
          return <Redirect to="/login" />;
        }
        console.log(roles)
        // Vérifier si l'utilisateur a les rôles requis
        if (roles && roles.length > 0) {
          // Convertir les rôles donnés au format attendu (ROLE_XXX)
          const formattedRoles: UserRole[] = roles.map(role => 
            role.startsWith('ROLE_') ? (role as UserRole) : (`ROLE_${role}` as UserRole)
          );
          console.log(formattedRoles)
          console.log(hasAnyRole(formattedRoles))
          if (!hasAnyRole(formattedRoles)) {
            return <Redirect to="/unauthorized" />;
          }
        }

        // Utiliser le layout Main si withLayout est vrai, sinon juste le composant
        return withLayout ? (
          <Main>
            <Component {...props} />
          </Main>
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};